export const Cnst = Object.freeze({
      ALL: '',
      PUBLISHED: true,
      UNPUBLISHED: false,
      BLOCKED: true,
      UNBLOCKED: false,
      IN_TRIP: true,
      SEPAR: false,
      MAX_NAME_SIZE: 48,
      MAX_ITEM_NAME_SIZE: 128,
      MAX_PWD_SIZE: 24,
      MAX_ITEM_SIZE: 20000,
      MAX_AUDIO_SIZE: 5000,
      MAX_IMG_SIZE: 5000,
      MAX_AVAT_SIZE: 1000
});
